<template>
  <count-to :start-val="startVal" :end-val="endVal" :duration="duration" :autoplay="autoplay" :decimals="decimals" :decimal="decimal" :separator="separator" :prefix="prefix" :suffix="suffix" :useEasing="useEasing" :easingFn="easingFn"></count-to>
</template>

<script>
  import CountTo from 'vue-count-to'

  import ScrollMagic from 'scrollmagic'
  import 'scrollmagic/scrollmagic/minified/plugins/debug.addIndicators.min.js'

  export default {
    components: {
      CountTo
    },
    props: {
      startVal: {
        type: Number,
        required: false,
        default: 0
      },
      endVal: {
        type: Number,
        required: false,
        default: 2017
      },
      duration: {
        type: Number,
        required: false,
        default: 3000
      },
      autoplay: {
        type: Boolean,
        required: false,
        default: true
      },
      decimals: {
        type: Number,
        required: false,
        default: 0,
        validator(value) {
          return value >= 0
        }
      },
      decimal: {
        type: String,
        required: false,
        default: '.'
      },
      separator: {
        type: String,
        required: false,
        default: ','
      },
      prefix: {
        type: String,
        required: false,
        default: ''
      },
      suffix: {
        type: String,
        required: false,
        default: ''
      },
      useEasing: {
        type: Boolean,
        required: false,
        default: true
      },
      easingFn: {
        type: Function,
        default (t, b, c, d) {
          return c * (-Math.pow(2, -10 * t / d) + 1) * 1024 / 1023 + b;
        }
      }
    },
    mounted() {
      var controller = new ScrollMagic.Controller();

      const self = this;

      new ScrollMagic.Scene({
          triggerElement: self.$el,
          duration: 0,
          triggerHook: "onEnter",
          reverse: false
        })
        .addTo(controller)
        .on("enter", function (e) {
          self.$children[0].start();
        })
        // .addIndicators();
    }
  }
</script>